import React, { HTMLInputTypeAttribute } from "react";

export interface LabeledInputProps {
    label : String,
    type: HTMLInputTypeAttribute,
    placeholder?: any,
    name?: any,
    value?: any,
    disabled?: boolean,
    maxLength?: number
}

const INPSTYLES = {
    fontFamily: "Poppins",
    fontWeight: 200,
    borderRadius: 10,
    padding: ".5rem",
    fontSize: 12,
}

const LABELSTYLES = {
    fontFamily: '"Poppins" sans-serif',
    margin: ".5rem 0",
    fontSize: 14,
}

const LabeledInput: React.FC<LabeledInputProps> = LabeledInputProps => {
    return (
        <>
            <label style={LABELSTYLES}>{LabeledInputProps.label}</label>
            <input
                maxLength={LabeledInputProps.maxLength}
                required 
                type={LabeledInputProps.type}
                style={INPSTYLES}
                name={LabeledInputProps.name}
                defaultValue={LabeledInputProps.value}
                placeholder={LabeledInputProps.placeholder}
                disabled={LabeledInputProps.disabled}>
            </input>
        </>
    )
}

export {
    LabeledInput
}